import i18n from '@/plugins/i18n'
import Model from './BaseModel'
import PlanModuleDiscount from './PlanModuleDiscount'

export default class PlanModule extends Model {
    resourceName() {
        return 'planModules'
    }

    fields() {
        return [
            'id',
            'plan_id',
            'module_id',
            'external_id',
            'name',
            'amount',
            'price',
            'over_price',
            'total_price',
            'total_over_price',
            'due_date',
            'created_at',
            'updated_at',
            'deleted_at',
        ]
    }

    relationships() {
        return {
            discounts: new PlanModuleDiscount(),
        }
    }

    dates() {
        return {
            due_date: 'YYYY-MM-DD',
            created_at: 'YYYY-MM-DD',
            updated_at: 'YYYY-MM-DD',
            deleted_at: 'YYYY-MM-DD',
        }
    }

    computed() {
        return {
            formattedDueDate(plan) {
                return plan.due_date.isValid()
                    ? i18n.d(plan.due_date, 'datetime')
                    : null
            },

            formattedCreatedAt(plan) {
                return plan.created_at.isValid()
                    ? i18n.d(plan.created_at, 'datetimewtsec')
                    : null
            },

            formattedUpdatedAt(plan) {
                return plan.updated_at.isValid()
                    ? i18n.d(plan.updated_at, 'datetime')
                    : null
            },

            formattedDeletedAt(plan) {
                return plan.deleted_at.isValid()
                    ? i18n.d(plan.deleted_at, 'datetime')
                    : null
            },
        }
    }
}
